// API-URL-Konfiguration und Hilfsfunktionen

export const getApiUrl = (): string => {
  if (process.env.REACT_APP_API_URL) {
    const apiUrl = process.env.REACT_APP_API_URL;
    return apiUrl.endsWith('/api') ? apiUrl.slice(0, -4) : apiUrl;
  }

  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const port = typeof window !== 'undefined' ? window.location.port : '';

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // Docker/Nginx auf 80/443/62123: gleiche Origin. CRA (3000) und Tests: API auf 3001.
    if (port === '80' || port === '443' || port === '62123') {
      return '';
    }
    return 'http://localhost:3001';
  }

  // Coolify und andere Reverse Proxies: gleiche Origin, Nginx proxyt /api und /uploads.
  return '';
};

export const API_URL = getApiUrl();
